import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './HistoryOrderPage.module.scss';
import HistoryOrderItem from "../../components/HistoryOrderItem/HistoryOrderItem";
import {orderActions} from "../../store/slices/orderSlice";
import Loader from "../../components/Loader/Loader";
import EmptyState from "../EmptyState/EmptyState";
import waiting from '../../constants/images//detailsOrder/waiting.svg';
import IsCleaner from "../../HOC/IsCleaner";

const HistoryOrderPage = () => {
    const dispatch = useDispatch();
    const {finishedOrdersByCleaner, status} = useSelector(state => state.order);

    useEffect(() => {
        const getFinishedOrdersByCleaner = async () => {
            await dispatch(orderActions.getFinishedOrdersByCleaner());
        }

        getFinishedOrdersByCleaner();
    }, [])

    if (status === 'loading') {
        return <Loader/>;
    }

    return (
        <div className={styles.historyOrderPage_wrapper}>
            <div className={styles.historyOrderPage}>
                <div className={styles.historyOrderPage_titleContainer}>
                    <h1 className={styles.historyOrderPage_titleContainer_title}>Історія замовлень</h1>

                    {/*<div className={styles.historyOrderPage_titleContainer_salary}>*/}
                    {/*    <div className={styles.historyOrderPage_titleContainer_salary_option}>*/}
                    {/*        <p>Зароблено за</p>*/}
                    {/*        <DropdownMonths/>*/}
                    {/*    </div>*/}
                    {/*    <p>₴ 15000 </p>*/}
                    {/*</div>*/}
                </div>

                <div className={styles.historyOrderPage_content}>
                    <div className={styles.historyOrderPage_content_history}>
                        {finishedOrdersByCleaner?.length === 0 &&
                            <EmptyState description={''} title={'На жаль, у вас поки немає активних замовлень'}
                                        icon={waiting}/>}

                        {finishedOrdersByCleaner.map((order, index) =>
                            <HistoryOrderItem key={index} order={order}/>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsCleaner(HistoryOrderPage);
